<div ngbDropdown [placement]="'top'" class="dropdown dropdown-inline mr-2" >
    <button class="btn btn-primary" ngbDropdownToggle mat-raised-button color="primary">Preview Display Order</button>
    <div ngbDropdownMenu>
        <button type="button" style="width: 170px;" mat-raised-button color="primary" (click)="OpenAppView()">Preview App Form</button><br>
        <button type="button" style="width: 170px;" mat-raised-button color="primary" (click)="OpenWebView()">Preview Web Form</button>                
    </div>
</div>